import { Controller } from "@hotwired/stimulus";

export default class UsersPagedListController extends Controller {
    static targets = [
        "isSuperAdmin",
        "isExternal",
    ];

    readonly isSuperAdminTarget!: HTMLElement;
    readonly isExternalTarget!: HTMLElement;

    connect() {
        var isSuperAdminJquery = $(this.isSuperAdminTarget);
        var forms = isSuperAdminJquery.closest("form") as JQuery<HTMLFormElement>;
        if (!forms || forms.length !== 1) throw new Error("Cannot find enclosing form.")
        var form = forms[0];

        this.isSuperAdminTarget.addEventListener("change", () => {
            form.requestSubmit();
        });

        this.isExternalTarget.addEventListener("change", () => {
            form.requestSubmit();
        });
    }
}